import { useRef } from 'react'

import { getAIConversationMessages } from '../../../../../api'
import { useApi } from '../../../../../hooks'
import { GRETA_AI_CHAT_HISTORY_PARAMS } from '../useGretaAIChatHistory.constants'
import {
  getHasNextGretaAIChatMessagesPage,
  mapGretaAIChatMessages,
  prependGretaAIChatOlderMessages,
} from '../useGretaAIChatHistory.utils'

export function useGretaAIChatOlderMessages({ activeChatId, setMessages }) {
  const olderApi = useApi()

  const pageRef = useRef(1)
  const hasOlderRef = useRef(false)
  const isLoadingOlderRef = useRef(false)

  function resetOlderMessages(firstPageResponse = null) {
    olderApi.abort()
    pageRef.current = 1
    hasOlderRef.current = getHasNextGretaAIChatMessagesPage(firstPageResponse)
  }

  function abortOlderMessages() {
    olderApi.abort()
  }

  function loadOlderMessages() {
    if (!hasOlderRef.current || isLoadingOlderRef.current) {
      return false
    }

    isLoadingOlderRef.current = true

    const nextPage = pageRef.current + 1

    olderApi.call(async ({ options }) => {
      try {
        const response = await getAIConversationMessages({
          id: activeChatId,
          options,
          params: { ...GRETA_AI_CHAT_HISTORY_PARAMS, page: nextPage },
        })

        if (response) {
          pageRef.current = nextPage
          hasOlderRef.current = getHasNextGretaAIChatMessagesPage(response)
          setMessages(current =>
            prependGretaAIChatOlderMessages(
              mapGretaAIChatMessages(response),
              current
            )
          )
        }
      } catch {
        // A background older-page load stays silent on failure.
      } finally {
        isLoadingOlderRef.current = false
      }
    })

    return true
  }

  return { abortOlderMessages, loadOlderMessages, resetOlderMessages }
}
